// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

/** Returns the default ship-to for pickup, or the first existing (non-new) ship-to. */
export const getDefaultPickupShipTo = (shipTos?: ShipToModel[]): ShipToModel | null => {
    if (!shipTos?.length) {
        return null;
    }

    const existingShipTos = shipTos.filter(s => !s.isNew);
    if (!existingShipTos.length) {
        return null;
    }

    return existingShipTos.find(s => s.isDefault) ?? existingShipTos[0];
};
